import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {PaginationComponent} from "@components/pagination/pagination.component";
import {SearchPanelComponent} from "@components/search-panel/search-panel.component";

import {ApiService} from '@services/api.service';
import {catchError, map} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {HttpClientModule} from '@angular/common/http';
import {UtilsService} from '@services/utils.service';
import {ImsDocumentsInputs} from '../../models/input.model';
import {
  DocumentType,
  DocumentTypeListResponse,
  ImsDocumentItem,
  ImsDocumentsListResponse,
} from '../../models/output.model';
import {SearchConfigRequest} from '../../models/search-config.model';
import {Router} from '@angular/router';

@Component({
  selector: 'app-ims',
  imports: [CommonModule, HttpClientModule, PaginationComponent, SearchPanelComponent, NgOptimizedImage],
  templateUrl: './ims.component.html',
  styleUrl: './ims.component.css'
})
export class ImsComponent implements OnInit {

  @Output() navigate = new EventEmitter<string>();

  @ViewChild('iframe') private iframeElement!: ElementRef<HTMLIFrameElement>;

  documents$!: Observable<ImsDocumentItem[]>;
  totalRows: number = 0;

  searchPanelConfig: SearchConfigRequest[] = [
    {key: 'name', label: 'Nome', type: 'text', options: []},
    {key: 'department_id', label: 'Tipo', type: 'select', options: []},
    {key: 'date_from', label: 'Dal', type: 'date', options: []},
    {key: 'date_to', label: 'Al', type: 'date', options: []},
  ]

  currentSort: {
    field: string; order: 'asc' | 'desc'
  } = {
    field: 'id',
    order: 'desc',
  }
  pagingParams!: {offset: number, limit: number};
  currentFilters: ImsDocumentsInputs | {} = {}

  constructor(
    private apiService: ApiService,
    private utilsSvc: UtilsService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.fetchDocumentsTypes()
    this.pagingParams = this.utilsSvc.pagination
    this.currentSort = {... this.currentSort, ...this.pagingParams};
    this.fetchDocuments(this.currentSort)
  }

  refresh(): void {
    this.pagingParams = {...this.utilsSvc.pagination, ...{offset:0}}
    this.currentFilters = {...this.currentFilters, ...this.currentSort , ...{offset:0} }
    this.fetchDocuments(this.currentFilters)
  }

  fetchDocumentsTypes(): void {

    const typeConfig = this.searchPanelConfig.find((config: SearchConfigRequest) => config.key === 'department_id')
    if (typeConfig) {
      this.apiService.getImsDocumentTypes().pipe(
        map((response: DocumentTypeListResponse) => response.data.sort((a: DocumentType, b: DocumentType) => a.label.localeCompare(b.label))),
        catchError(error => {
          console.error("Errore nel recupero dei types", error);
          return of([])
        })
      ).subscribe({
        next: (types: DocumentType[]) => {
          typeConfig.options = types.map((item: DocumentType) => {
            return {
              label: item.label,
              value: item.id + ""
            };
          });
        },
        error: error => {
          console.error("Errore nel recupero dei types", error);
        }
      })
    }
  }

  fetchDocuments(params: ImsDocumentsInputs | {}) {

    params = {
      ...params,
      order: this.currentSort.order,
      order_field: this.currentSort.field
    }

    this.documents$ = this.apiService.getImsDocuments(params).pipe(
      map((response: ImsDocumentsListResponse) => {
        if (response.result.status != 'error') {
          this.totalRows = response.result.total_row
          return response.result.data
        } else {
          return []
        }
      }),
      catchError(error => {
        console.error("Errore nel recupero dei documenti ims", error);
        return of([])
      })
    )
  }


  setOrder(field: string) {
    if (this.currentSort.field === field) {
      this.currentSort.order = this.currentSort.order === 'asc' ? 'desc' : 'asc';
    } else {
      this.currentSort.field = field;
      this.currentSort.order = 'asc'
    }
    this.fetchDocuments(this.currentFilters)
  }

  goToPage(page: ImsDocumentsInputs) {
    this.currentFilters = {...this.currentFilters, ...this.currentSort , ...page}
    this.onSearchParamChange(page)
  }

  onSearchParamChange(params: ImsDocumentsInputs): void {
    if(params == null || Object.keys(params).length === 0) {
      this.currentFilters = { ...this.currentSort }
    } else {
      this.currentFilters = { ...this.currentSort, ...params }
    }
    this.fetchDocuments(this.currentFilters);
  }



  closePreview() {
    this.iframeElement.nativeElement.removeAttribute('src');
  }
  onRowClicked(id: number) {
      this.router.navigate(['/documenti-sgi', id])
  }



}
